import React, { useState } from 'react';
import { Drawer, Tooltip } from 'antd';
import { CloseXIcon, LayerIcon } from 'icons';
import { useTranslations } from 'next-intl';

import { ModuleLesson } from 'modules/course-detail';
import { courseConst, ILesson, IModule } from 'modules/courses';

import { Visible } from 'components';

import { Lesson } from './lesson-list';
import { Stats } from './stats';

interface IProps {
  lessonCount?: number;
  duration?: number;
  lessons?: ILesson[];
  modules?: IModule[];
  type?: courseConst.CourseLesssonType;
}

export const LessonsDrawer = ({ lessonCount, duration, lessons, type, modules }: IProps) => {
  const t = useTranslations();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip title={t('kurs_royhati')}>
        <div
          className="flex size-8 cursor-pointer items-center justify-center rounded-lg bg-gray-200 text-gray-800 hover:bg-gray-300"
          onClick={() => setOpen(true)}
        >
          <LayerIcon />
        </div>
      </Tooltip>
      <Drawer
        closable={false}
        width={547}
        placement="right"
        title={<p className="font-semibold">{t('kurs_tarkibi')}</p>}
        open={open}
        extra={
          <button onClick={() => setOpen(false)} className="flex cursor-pointer items-center">
            <CloseXIcon />
          </button>
        }
        onClose={() => setOpen(false)}
      >
        <div>
          <Stats lessonCount={lessonCount} duration={duration} className="mt-3 flex-wrap" />
        </div>
        <div className="mt-4 space-y-3">
          <Visible
            if={type === courseConst.CourseLesssonType.MODULAR}
            else={lessons?.map(lesson => (
              <Lesson
                key={lesson?.id}
                duration={lesson?.duration}
                title={lesson?.title}
                slug={lesson?.slug}
                progress={lesson?.progress}
                available={lesson?.open}
              />
            ))}
          >
            <ModuleLesson modules={modules} isDrawer>
              {lesson => (
                <Lesson
                  key={lesson?.id}
                  duration={lesson?.duration}
                  title={lesson?.title}
                  slug={lesson?.slug}
                  progress={lesson?.progress}
                  available={lesson?.open}
                />
              )}
            </ModuleLesson>
          </Visible>
        </div>
      </Drawer>
    </>
  );
};
